import "./OurStory.css";

import SectionLineHeader from "../../../widgets/section-line-header/SectionLineHeader";
import storyCover from "../../../assets/images/about/arialview.png";
import CustomAnchor from "../../../shared/Anchor/CustomAnchor";

function OurStory() {
  return (
    <div className="d-block">
      <SectionLineHeader header="FROM SCIENCE TO THE FARM..." />
      <div className="d-block story-container">
        <div className="story-overlay">
          <div className="row m-0 h-100">
            <div className="col-lg-7 col-12 journey-steps">
              <h4>🌱 Discover the Journey</h4>
              <p>
                Watch how Farmer Brian turned challenges into thriving harvests.
              </p>
              <h4>🚜 Innovation Meets Tradition</h4>
              <p>
                Learn the secrets behind sustainable farming that feeds nations.
              </p>
              <h4>🛒 Market-Ready Harvests</h4>
              <p>
                See how eFarma bridges the gap between farmers and buyers
                effortlessly.
              </p>
            </div>
            <div className="col-lg col-12 story-cover">
              <CustomAnchor
                classname="achievement-cover-container"
                path={"https://www.youtube.com/embed/pWyRSC9u58w"}
                openOverlay={{
                  path: "https://www.youtube.com/embed/pWyRSC9u58w",
                  type: "youtube",
                  title:
                    "eFama Farmer Story: Brian Ndou's Journey from Scientist to Crop Farmer",
                }}
              >
                <svg
                  width="90"
                  height="90"
                  viewBox="0 0 576 512"
                  xmlns="https://www.w3.org/2000/svg"
                >
                  <path
                    fill="red"
                    d="M549.655 124.083c-6.281-23.65-24.764-42.167-48.398-48.454C460.626 64 288 64 288 64S115.374 64 74.743 75.629c-23.634 6.287-42.117 24.804-48.398 48.454C16 165.74 16 256.003 16 256.003s0 90.26 10.345 131.917c6.281 23.65 24.764 42.167 48.398 48.454C115.374 448 288 448 288 448s172.626 0 213.257-11.629c23.634-6.287 42.117-24.804 48.398-48.454 10.345-41.657 10.345-131.917 10.345-131.917s0-90.263-10.345-131.92z"
                  />
                  <path
                    fill="white"
                    d="M232 334.058V177.94L345 256.002 232 334.058z"
                  />
                </svg>
              </CustomAnchor>
            </div>
          </div>
        </div>
        <img src={storyCover} loading="eager" alt="Story Cover" onContextMenu={(e) => e.preventDefault()}/>
      </div>
    </div>
  );
}

export default OurStory;
